import { Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { MenuActionItem } from 'app/modules/wallforming/components/menu-container/MenuActionItem';

export const EditMenu = () => {
    const { t } = useTranslation();

    return (
        <Menu offset={0} position="bottom-start" shadow="md" trigger="click-hover">
            <Menu.Target>
                <button
                    className="px-4 py-0.5 text-sm font-medium text-text-default hover:bg-background-gray-strong! rounded transition-colors h-full focus-visible:outline-none"
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                >
                    {t('labelEditMenu')}
                </button>
            </Menu.Target>
            <Menu.Dropdown>
                <MenuActionItem.Transform />
                <MenuActionItem.Rotate />
                <Menu.Divider />
                <MenuActionItem.Cut />
                <MenuActionItem.Copy />
                <MenuActionItem.Paste />
                <Menu.Divider />
                <MenuActionItem.Group />
                <MenuActionItem.Ungroup />
                <MenuActionItem.EditGroup />
                <Menu.Divider />
                <MenuActionItem.DiscardSelection />
                <MenuActionItem.SelectAll />
                <Menu.Divider />
                <MenuActionItem.Delete />
            </Menu.Dropdown>
        </Menu>
    );
};
